import React from 'react';
import './index.sass';

const OfferItem = ({ icon, title, description }) => {
    return (
        <div className="OfferItem">
            <div className="OfferItem__Icon">
                <span className="OfferItem__Icon-Glow" aria-hidden="true" />
                {icon}
            </div>
            <h3 className='OfferItem__Title'>{title}</h3>
            <p className='OfferItem__Descr'>{description}</p>
        </div>
    );
};

export default OfferItem;
